import { gql } from 'glimmer-apollo';

export const ESPORTS_PLAYER_QUERY = gql`
  query ($slug: String) {
    player(slug: $slug) {
      irlName
      gamertag
      role
      slug
      socialLinks {
        url
        platform
        accessibilityDescription
      }
      currentTeam {
        name
        slug
        logo {
          url(width: 64, height: 64, fit: cover, format: webp)
        }
        matches {
          title
          scheduledDate
          slug
          victor {
            slug
          }
          rounds {
            victor {
              slug
            }
          }
          teams {
            name
            slug
            logo {
              url(width: 32, height: 32, fit: cover, format: webp)
            }
          }
        }
      }
      photo {
        url(width: 300, height: 300, fit: cover, format: webp)
      }
    }
  }
`;
